var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobHaikei3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1400 900",
    width: 1400,
    height: 800,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.39074040325329 870.6708192431009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.4 -669C501.5 -565.9 643.9 -509.9 602.6 -406.3C561.2 -302.7 336.1 -151.3 355.6 11.2C375.1 173.8 639.2 347.7 620.7 347.7C602.2 347.7 301.1 173.8 150.5 248.8C0 323.7 0 647.3 -74.7 776.7C-149.3 906 -298.7 841 -383.2 728C-467.8 615 -487.7 454 -481.3 324.7C-475 195.3 -442.5 97.7 -531.1 -51.2C-619.7 -200 -829.5 -400 -848.9 -552C-868.3 -704 -697.4 -807.9 -524.2 -886.8C-351 -965.6 -175.5 -1019.3 -27.9 -971C119.7 -922.6 239.3 -772.2 370.4 -669",
    fill: "#dcf0ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobHaikei3);
export default __webpack_public_path__ + "static/media/blob-haikei 3.0c97005be7ebb450916891e5c08ef9a0.svg";
export { ForwardRef as ReactComponent };